// ---------------------------------------------
// auto-generated from materia/prims.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { Icon } from "../screens-cristal/primitives.jsx";

// ────────────────────────────────────────────────────────────
// Materia primitives — striped chart placeholder + shells
// ────────────────────────────────────────────────────────────

export const MChip = ({ children, variant = "default", className = "", style }) => (
  <span className={`m-chip ${variant !== "default" ? variant : ""} ${className}`} style={style}>{children}</span>
);

export const MEye = ({ children, style }) => (
  <div className="m-eye" style={style}>{children}</div>
);

export const MObjective = ({ eye, children }) => (
  <div className="m-objective">
    <div>
      <div className="eye">{eye}</div>
      <div className="text" style={{ marginTop: 2 }}>{children}</div>
    </div>
  </div>
);

export const MSourceRail = ({ source = "vendor_primary · XYZ 1D", time = "14:32 UTC", live = true, note = "Educativo · No es asesoramiento" }) => (
  <div className="m-source-rail">
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span style={{ width: 6, height: 6, borderRadius: 99, background: live ? "var(--m-positive)" : "var(--m-text-3)", boxShadow: live ? "0 0 8px var(--m-positive)" : "none" }}/>
      <span>{live ? "LIVE · delay 15m" : "STATIC"}</span>
    </span>
    <span className="sep"/>
    <span style={{ color: "var(--m-text-2)" }}>{source}</span>
    <span className="sep"/>
    <span>retrieved {time}</span>
    <span className="sep"/>
    <span>confidence: medium</span>
    <span style={{ marginLeft: "auto", color: "var(--m-text-3)" }}>{note}</span>
  </div>
);

export const MNotAdvice = ({ children = "Educativo · No es asesoramiento" }) => (
  <span className="m-notadvice">{children}</span>
);

// ────────────────────────────────────────────────────────────
// MChart — striped placeholder with optional overlays
//   overlays:
//    - { type: 'zone', topPct, bottomPct, label, color }
//    - { type: 'hline', yPct, label, color, dashed }
//    - { type: 'marker', xPct, yPct, label, kind: 'decision'|'event'|'check'|'x' }
//    - { type: 'swing', xPct, yPct, label } HH/HL/LH/LL
//    - { type: 'trend', from:[x,y], to:[x,y] }
//    - { type: 'curve', d, color, dashed }  // raw SVG d
// ────────────────────────────────────────────────────────────
export const MRail = ({ active = "today" }) => (
  <div className="m-rail">
    <div style={{
      width: 36, height: 36, borderRadius: 8,
      background: "linear-gradient(180deg, #d4855a, #b46435)",
      display: "grid", placeItems: "center",
      boxShadow: "inset 0 1px 0 rgba(255,220,190,0.35), 0 4px 12px rgba(0,0,0,0.5)",
      marginBottom: 12,
    }}>
      <span className="mono" style={{ fontSize: 13, fontWeight: 700, color: "#1c0e07", letterSpacing: "-0.03em" }}>E</span>
    </div>
    {[
      { i: "today", t: "Hoy" },
      { i: "map", t: "Aprender" },
      { i: "explore", t: "Explora" },
      { i: "review", t: "Repaso" },
    ].map((n, k) => (
      <div key={k} className={`item ${active === n.i ? "active" : ""}`} title={n.t}>
        <Icon name={n.i} size={18}/>
      </div>
    ))}
    <div style={{ flex: 1 }}/>
    <div className="item" title="Perfil">
      <Icon name="profile" size={18}/>
    </div>
  </div>
);

// ────────────────────────────────────────────────────────────
// MTopBar
// ────────────────────────────────────────────────────────────
export const MTopBar = ({ crumbs = [], children, time = "14:32 UTC" }) => (
  <div className="m-topbar">
    <div className="m-breadcrumb">
      {crumbs.map((c, i) => (
        <React.Fragment key={i}>
          <span className={i === crumbs.length - 1 ? "now" : ""}>{c}</span>
          {i < crumbs.length - 1 && <span className="sep">/</span>}
        </React.Fragment>
      ))}
    </div>
    <div style={{ flex: 1, display: "flex", justifyContent: "center", gap: 6 }}>
      {children}
    </div>
    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
      <span className="m-chip live">live · {time}</span>
      <button className="m-iconbtn"><Icon name="search" size={15}/></button>
      <button className="m-iconbtn"><Icon name="help" size={15}/></button>
      <div style={{
        width: 32, height: 32, borderRadius: 99,
        background: "linear-gradient(135deg, #c97a4b, #d8a868)",
        display: "grid", placeItems: "center", fontSize: 12, color: "#1c0e07", fontWeight: 700,
      }}>M</div>
    </div>
  </div>
);

export const MRenderModeSwitcher = ({ mode = "movie" }) => (
  <div className="m-panel" style={{
    display: "inline-flex", padding: 3, gap: 2, height: 32,
    borderRadius: 6, boxShadow: "none", background: "var(--m-bg-deep)",
  }}>
    {[
      { i: "movie", l: "Movie" },
      { i: "explore", l: "Explore" },
      { i: "book", l: "Reading" },
      { i: "headset", l: "Audio" },
    ].map((m, i) => {
      const on = m.i === mode;
      return (
        <button key={i} style={{
          height: 26, padding: "0 12px", gap: 6,
          display: "inline-flex", alignItems: "center",
          border: "none", borderRadius: 4,
          fontFamily: "var(--m-t-mono)", fontSize: 11, letterSpacing: "0.06em", textTransform: "uppercase",
          background: on ? "var(--m-metal)" : "transparent",
          color: on ? "var(--m-text)" : "var(--m-text-3)",
          boxShadow: on ? "var(--m-bevel-top)" : "none",
          cursor: "pointer",
        }}>
          <Icon name={m.i} size={11}/>
          <span>{m.l}</span>
        </button>
      );
    })}
  </div>
);

// ────────────────────────────────────────────────────────────
// MAppShell — 3-pane desktop layout
// children: { left, center, right }
// ────────────────────────────────────────────────────────────
export const MAppShell = ({ active = "today", crumbs = [], topbarExtra = null, left, center, right, sourceRail = true, sourceProps = {} }) => (
  <div className="materia" style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
    <MRail active={active}/>
    <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
      <MTopBar crumbs={crumbs}>{topbarExtra}</MTopBar>
      <div style={{ flex: 1, display: "flex", minHeight: 0 }}>
        {left && <div style={{ width: 280, borderRight: "1px solid var(--m-line)", display: "flex", flexDirection: "column", background: "rgba(0,0,0,0.18)" }}>{left}</div>}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
          {center}
        </div>
        {right && <div style={{ width: 360, borderLeft: "1px solid var(--m-line)", display: "flex", flexDirection: "column", background: "rgba(0,0,0,0.18)" }}>{right}</div>}
      </div>
      {sourceRail && <MSourceRail {...sourceProps}/>}
    </div>
  </div>
);

// ────────────────────────────────────────────────────────────
// Concept Graph (for left rail · "Mapa de conceptos")
// ────────────────────────────────────────────────────────────
export const MConceptGraph = ({ nodes = [], edges = [], focus = null, width = 260, height = 280 }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}
       style={{ display: "block", margin: "0 auto" }}>
    {edges.map((e, i) => {
      const a = nodes[e[0]], b = nodes[e[1]];
      return <line key={i} x1={a.x} y1={a.y} x2={b.x} y2={b.y}
        stroke="rgba(216,196,160,0.18)" strokeWidth="1" strokeDasharray={e[2] === "dashed" ? "2 3" : "0"}/>;
    })}
    {nodes.map((n, i) => {
      const isFocus = n.k === focus;
      const c = n.s === "done" ? "var(--m-positive)" :
                n.s === "now"  ? "var(--m-primary)" :
                n.s === "next" ? "var(--m-accent)" : "var(--m-text-3)";
      return (
        <g key={i}>
          <circle cx={n.x} cy={n.y} r={isFocus ? 10 : 7}
            fill="var(--m-bg-deep)" stroke={c} strokeWidth={isFocus ? 2 : 1.2}/>
          {n.s === "done" && <circle cx={n.x} cy={n.y} r={3} fill={c}/>}
          {n.s === "now" && <circle cx={n.x} cy={n.y} r={3} fill={c}/>}
          <text x={n.x + 14} y={n.y + 4} fontFamily="var(--m-t-mono)" fontSize="10"
            fill={isFocus ? "var(--m-text)" : "var(--m-text-2)"}>{n.t}</text>
        </g>
      );
    })}
  </svg>
);

// Real klinecharts-powered MChart (replaces the placeholder above)
export { MChartReal as MChart } from "../lib/chart-real.jsx";
